export const environment = {
    production: true,
   //baseUrl: 'https://localhost:7252/api',  
    //redirectUri: 'http://localhost:4200/timesheet'
    baseUrl: 'https://smetimesheetapi.i2econsulting.com/api',
    redirectUri: 'https://smetimesheet.i2econsulting.com/timesheet/timesheet-n'
  };

  